<template>
  <v-btn
    v-bind="$attrs"
    block
    elevation="0"
    color="elements elementsText--text"
    :rounded="layoutShape.roundButton"
    :outlined="layoutShape.button === 'outlined'"
    v-on="$listeners">
    {{ title }}
  </v-btn>
</template>
<script>
import { eventBus } from '../../main.js'
export default {
  name: 'BasePrimaryBtn',
  props: {
    title: { type: String, default () { return '' } },
    parentWidget: { type: String, default () { return '' } },
  },
  eventListenerId: null,
  data () {
    return {
      layoutShape: null,
    }
  },
  created () {
    this.layoutShape = this.$store.getters.getConfigJson.layoutShape
  },
  mounted () {
    this.$options.eventListenerId = eventBus.$on('enter-pressed', (activeTool) => {
      if (this.parentWidget.substring(0, this.parentWidget.length - 4).toLowerCase() === activeTool &&
          this.$attrs.loading !== true &&
          this.$attrs.disabled !== true) {
        this.$emit('click')
      }
    })
  },
  destroyed () {
    eventBus.$off('enter-pressed', this.$options.eventListenerId)
  },
}
</script>
